/**
 * Dev Mode Persistence
 * Handles loading and saving dev mode state to localStorage
 */

const DEV_MODE_STORAGE_KEY = 'interax_dev_mode_enabled'

/**
 * Load dev mode state from localStorage
 * @returns true if dev mode is enabled, false otherwise (default: false)
 */
export const loadDevModeFromStorage = (): boolean => {
  if (typeof window === 'undefined') return false

  try {
    const stored = localStorage.getItem(DEV_MODE_STORAGE_KEY)
    if (!stored) return false

    return JSON.parse(stored) === true
  } catch (error) {
    console.warn('Failed to load dev mode from localStorage:', error)
    return false
  }
}

/**
 * Save dev mode state to localStorage
 * @param enabled - Whether dev mode should be enabled
 */
export const saveDevModeToStorage = (enabled: boolean): void => {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(DEV_MODE_STORAGE_KEY, JSON.stringify(enabled))
  } catch (error) {
    console.warn('Failed to save dev mode to localStorage:', error)
  }
}

/**
 * Clear dev mode state from localStorage
 */
export const clearDevModeFromStorage = (): void => {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(DEV_MODE_STORAGE_KEY)
  } catch (error) {
    console.warn('Failed to clear dev mode from localStorage:', error)
  }
}
